import { BASE_URL, VDS_BASE_URL } from "../constants/ApiUrls";
import axios from "axios";

const headers = {
  Authorization: "Bearer" + localStorage.getItem("token"),
};

export const getData = async (api, key) => {
  let url = BASE_URL + api;
  try {
    const data = await axios.get(url);
    if (data.status === 400) return data?.data?.message;
    else if (data.status === 204) return data;
    return data.data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getVdsData = async (api, key) => {
  let url = VDS_BASE_URL + api;
  try {
    const { data, status } = await axios.get(url);
    if (status === 400) return data?.message;
    return data;
  } catch (error) {
    return error.response?.data;
  }
};
export const updateVdsData = async (api, dataObj) => {
  let url = VDS_BASE_URL + api;
  try {
    const { data } = await axios.put(url, dataObj);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const postData = async (api, dataObj) => {
  let url = BASE_URL + api;
  try {
    const { data } = await axios.post(url, dataObj);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const postVdsData = async (api, dataObj) => {
  let url = VDS_BASE_URL + api;
  try {
    const { data } = await axios.post(url, dataObj);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const deleteData = async (api, key = "") => {
  let url = BASE_URL + api + key;
  try {
    const { data } = await axios.delete(url);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};

export const updateData = async (api, dataObj = {}) => {
  let url = BASE_URL + api;
  try {
    const { data } = await axios.put(url, dataObj);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};
export const patchData = async (api, dataObj) => {
  let url = BASE_URL + api;
  try {
    const { data } = await axios.patch(url, dataObj);
    return data;
  } catch (error) {
    return error.response?.data;
  }
};
export const getXMLData = async (api, fileName, extension) => {
  try {
    return await axios
      .get(BASE_URL + api, {
        responseType: "blob",
      })
      .then((response) => {
        let data = { status: 200 };
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName + extension);
        document.body.appendChild(link);
        link.click();
        return data;
      });
  } catch (error) {
    return error.response;
  }
};
export const postXMLData = async (api, fileName, extension) => {
  try {
    return await axios
      .post(BASE_URL + api, {
        responseType: "blob",
      })
      .then((response) => {
        let data = { status: 200 };
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName + extension);
        document.body.appendChild(link);
        link.click();
        return data;
      });
  } catch (error) {
    return error.response;
  }
};
